export default __webpack_public_path__ + "static/media/modra-strecha-favicon-v2.3255c559.svg";